import {
    boolean,
    literal,
    nativeEnum,
    number,
    object,
    string,
    TypeOf,
} from 'zod';

import { Alignment, CornerStyle, ElementType, Ratio } from '../common';

/* ------------------------------ SlideOptions ------------------------------ */

export const SlideOptions = object({
    ageRating: object({ visible: boolean() }),
    description: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    duration: object({ displaySeconds: boolean(), visible: boolean() }),
    image: object({
        cornerStyle: nativeEnum(CornerStyle),
        ratio: nativeEnum(Ratio),
    }),
    name: object({ alignment: nativeEnum(Alignment), visible: boolean() }),
    published: object({ visible: boolean() }),
    releaseDate: object({ visible: boolean() }),

    /* START Not Currently in the API */
    liveEventStatus: object({
        visible: boolean(),
    }).default({
        visible: true,
    }),
    /* END */
});

export type SlideOptions = TypeOf<typeof SlideOptions>;

/* ----------------------------- CarouselOptions ---------------------------- */

export const CarouselOptions = object({
    name: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    description: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    tile: SlideOptions,

    /* START Not Currently in the API */
    margin: boolean().default(true),
    autoSpin: object({
        enabled: boolean(),
        pauseDuration: number(),
    }).default({
        enabled: true,
        pauseDuration: 10000,
    }),
    /* END */
});

export type CarouselOptions = TypeOf<typeof CarouselOptions>;

/* --------------------------- CarouselPageElement -------------------------- */

export const CarouselPageElement = CarouselOptions.deepPartial().extend({
    id: string(),
    type: literal(ElementType.Carousel),
    collectionId: string(),
});

export type CarouselPageElement = TypeOf<typeof CarouselPageElement>;
